export default __webpack_public_path__ + "static/media/logo.9b61f2da.png";